import { render, staticRenderFns } from "./VatDialog.vue?vue&type=template&id=8d810d0a&scoped=true"
import script from "./VatDialog.vue?vue&type=script&lang=js"
export * from "./VatDialog.vue?vue&type=script&lang=js"
import style0 from "./VatDialog.vue?vue&type=style&index=0&id=8d810d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d810d0a",
  null
  
)

export default component.exports